export function isFlowSlugOnboarding(flowSlug: string) {
  return flowSlug.includes("onboarding");
}
